import React from 'react';

import {
  Contact,
  FAQs,
  Plans,
  PlansExpanded,
  PlanTabs,
  Trusted,
} from '@/modules/payment';
import { useGetPaymentBundles } from '@/modules/payment/apiHooks';
import { SubscriptionProvider } from '@/modules/payment/subscription/context/context';
import { handleSortingBundles } from '@/modules/payment/subscription/logic';
import { IPayment } from '@/modules/payment/types';
import FloatingSubscriptionCard from '@/shared/components/molecules/FloatingSubscriptionCard';
import useCheckSubscriptionStatus from '@/shared/hooks/useCheckSubscriptionStatus';

const Subscription = () => {
  const { data } = useGetPaymentBundles();
  const sortedBundles: IPayment.IBundleSchema[] = handleSortingBundles(
    data ?? []
  );

  const showSubscriptionCTA = useCheckSubscriptionStatus();

  return (
    <SubscriptionProvider>
      <div className='flex flex-col'>
        <PlanTabs />
        <Plans bundles={sortedBundles} />
        <Trusted />
        <PlansExpanded bundles={sortedBundles} />
        <FAQs />
        <Contact />
      </div>
      {showSubscriptionCTA && <FloatingSubscriptionCard />}
    </SubscriptionProvider>
  );
};

export { Subscription };
